function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react/button-has-type */
import React from 'react';
import c from 'classnames';
import LoadingIndicator from '../LoadingIndicator';
const Button = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    type = 'primary',
    className,
    children,
    icon,
    disabled,
    variation,
    CustomLinkComponent,
    isLoading = false
  } = props;
  const classNames = c({
    button: type !== 'link',
    a: type === 'link',
    'no-styling': type === 'link',
    'button--is-loading': isLoading,
    ...(icon && {
      ["icon-".concat(icon)]: icon
    }),
    ...(variation && {
      ["button--".concat(variation)]: variation
    })
  }, "button--".concat(type), className);

  // If `href` is present in props, render an <a></a>.
  if ('href' in props) {
    const {
      href
    } = props;
    const LinkComponent = CustomLinkComponent || 'a';
    return /*#__PURE__*/React.createElement(LinkComponent, _extends({}, props, {
      href: href,
      className: classNames,
      "aria-disabled": disabled || isLoading
    }), children, isLoading && /*#__PURE__*/React.createElement(LoadingIndicator, {
      variant: type === 'primary' ? 'dark' : 'light'
    }));
  }

  // If no `href` is present in props, render a <button></button>.
  const {
    htmlType = 'button'
  } = props;
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    ref: ref,
    className: classNames,
    type: htmlType,
    "aria-disabled": disabled || isLoading
  }), children, isLoading && /*#__PURE__*/React.createElement(LoadingIndicator, {
    variant: type === 'primary' ? 'dark' : 'light'
  }));
});
export default Button;